import { z } from "zod";

export const MAX_REASON_LENGTH = 500;

export const disableReasonSchema = z.object({
  reason: z
    .string()
    .transform((value) => value.trim())
    .pipe(
      z
        .string()
        .min(1, "modules.dialog.validation.reasonRequired")
        .max(MAX_REASON_LENGTH, "modules.dialog.validation.reasonTooLong"),
    ),
});

export const enableReasonSchema = z.object({
  reason: z
    .string()
    .transform((value) => value.trim())
    .pipe(
      z
        .string()
        .max(MAX_REASON_LENGTH, "modules.dialog.validation.reasonTooLong"),
    ),
});

export type DisableReasonForm = { reason: string };
export type EnableReasonForm = { reason: string };
